import { render, staticRenderFns } from "./StorageDelegateDialog.vue?vue&type=template&id=8dc55d64&"
import script from "./StorageDelegateDialog.vue?vue&type=script&lang=js&"
export * from "./StorageDelegateDialog.vue?vue&type=script&lang=js&"
import style0 from "./StorageDelegateDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports